import moment, { DurationInputArg1, DurationInputArg2, Moment, MomentInput } from 'moment';
import momentTz from 'moment-timezone';

// Timezone used by the entire Fluz backend for all its timestamps.
const fluzBackendTimeZone = 'America/New_York';

export const dayName = (date: MomentInput) => moment(date).format('dddd');
export const dayLocale = (date: MomentInput) => moment(date).format('LLL');
export const formatDate = (date: MomentInput, format: string) => moment(date).format(format);

export const getCurrentTimezone = () => {
  return momentTz.tz.guess();
};

export const formatDateWithTimezone = (date: MomentInput, format: string | undefined) => {
  const dateObject = momentTz.utc(date ?? new Date());
  const userTimezone = getCurrentTimezone();
  return dateObject
    .tz(userTimezone)
    .format(format ? format.replace('$timezoneAbbr', dateObject.tz(userTimezone).format('z')) : undefined);
};

export const getRelativeTime = (date: MomentInput) => {
  const dateObject = momentTz.utc(date ?? new Date());
  const userTimezone = momentTz.tz.guess();
  return dateObject.tz(userTimezone).fromNow();
};

export const differenceInDays = (currentDate: MomentInput, comparedTo: MomentInput) => {
  const a = moment(currentDate);
  const b = moment(comparedTo);

  return Math.abs(b.diff(a, 'days'));
};

export const differenceInHours = (date: Date) => {
  const currentUTC = moment.utc();
  const comparedTo = moment(date);

  return currentUTC.diff(comparedTo, 'hours');
};

export const addTime = (duration: DurationInputArg1, type: DurationInputArg2, from?: Moment) => {
  /*
   * y - years
   * Q - quarters
   * M - months
   * w - weeks
   * d - days
   * h - hours
   * m - minutes
   * s - seconds
   * ms - milliseconds
   */
  const addedTime = moment(from).add(duration, type);
  return addedTime;
};

export const differenceInUnitOfTime = (expiryDateTime: Moment, unitOfTime: DurationInputArg2) => {
  /*
   * y - years
   * Q - quarters
   * M - months
   * w - weeks
   * d - days
   * h - hours
   * m - minutes
   * s - seconds
   * ms - milliseconds
   */
  return moment(expiryDateTime).diff(moment(), unitOfTime);
};

export const isBetweenTime = (start: Moment, end: Moment) => {
  const now = new Date();
  return start.isBefore(now) && end.isAfter(now);
};

export const isToday = (date: Date) => {
  const today = new Date();
  return (
    date.getFullYear() === today.getFullYear() &&
    date.getMonth() === today.getMonth() &&
    date.getDate() === today.getDate()
  );
};

export const now = () => {
  const timeNow = moment();
  return momentTz.tz(timeNow, getCurrentTimezone());
};

export const backendNow = () => {
  const timeNow = moment();
  return momentTz.tz(timeNow, fluzBackendTimeZone);
};
